export class AcButton extends HTMLElement {
    connectedCallback() {
        this.render();
    }
    attributeChangedCallback() {
        this.render();
    }
    render() {
        const variant = this.getAttribute("variant") ?? "primary";
        const bg = variant === "primary" ? "#22d3ee" : "#232842";
        this.style.display = "inline-block";
        this.style.cursor = "pointer";
        this.style.userSelect = "none";
        this.style.padding = "12px 20px";
        this.style.borderRadius = "12px";
        this.style.background = bg;
        this.style.color = "#fff";
        this.style.fontWeight = "600";
        this.style.textAlign = "center";
        this.style.transition = "transform .08s ease";
        this.onpointerdown = () => (this.style.transform = "scale(0.96)");
        this.onpointerup = () => (this.style.transform = "scale(1)");
        this.onpointerleave = () => (this.style.transform = "scale(1)");
    }
}
Object.defineProperty(AcButton, "observedAttributes", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: ["variant"]
});
customElements.define("ac-button", AcButton);
